import { render, staticRenderFns } from "./bigView.vue?vue&type=template&id=39defc26&scoped=true"
import script from "./bigView.vue?vue&type=script&lang=js"
export * from "./bigView.vue?vue&type=script&lang=js"
import style0 from "./bigView.vue?vue&type=style&index=0&id=39defc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39defc26",
  null
  
)

export default component.exports